<template>
  <!--
    مینی‌گزارش صفحه‌ی جزئیات یک موجودیت (محصول، مشتری، …).
    به‌صورت آکاردئون بسته شروع می‌شود: صفحه‌ی جزئیات برای ویرایش باز می‌شود،
    نه برای تحلیل — پس گزارش نباید فرم را عقب بیندازد یا کوئری سنگین
    بی‌درخواست بزند. اولین باز شدن، داده را می‌گیرد.
  -->
  <b-card no-body>
    <b-card-header
      class="entity-report__header"
      role="button"
      @click="toggle"
    >
      <div>
        <b-card-title class="mb-25">
          {{ title }}
        </b-card-title>
        <span class="entity-report__hint">{{ open ? rangeLabel : 'برای دیدن روند و آمار کلیک کنید' }}</span>
      </div>
      <feather-icon
        :icon="open ? 'ChevronUpIcon' : 'ChevronDownIcon'"
        size="18"
      />
    </b-card-header>

    <b-collapse v-model="open">
      <b-card-body class="pt-0">
        <div class="d-flex flex-wrap align-items-end mb-1">
          <b-button
            v-for="item in presets"
            :key="item.key"
            size="sm"
            class="mr-50 mb-25"
            :variant="preset === item.key ? 'primary' : 'flat-secondary'"
            @click="applyPreset(item.key)"
          >
            {{ item.title }}
          </b-button>

          <div class="flex-grow-1" />

          <b-spinner
            v-if="isAnyLoading"
            small
            variant="primary"
          />
        </div>

        <!-- نتایج در اسکوپ اسلات پاس داده می‌شوند تا والد نیازی به state نداشته باشد -->
        <slot
          :data="results"
          :skin="skin"
          :loading="loading"
          :range-label="rangeLabel"
        />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { BCardHeader, BCardTitle, BCardBody, BCollapse } from 'bootstrap-vue'
import reportMixin from '@core/mixins/report'

export default {
  name: 'EntityReportPanel',
  components: {
    BCardHeader, BCardTitle, BCardBody, BCollapse,
  },
  mixins: [reportMixin],
  props: {
    title: {
      type: String,
      default: 'گزارش',
    },
    // شناسه‌ی موجودیت؛ به همه‌ی درخواست‌ها اضافه می‌شود
    entityId: {
      type: [Number, String],
      default: null,
    },
    // فهرست { key, url } برای واکشی
    sources: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
      loaded: false,
      results: {},
      // پریست کوتاه‌تر از صفحات گزارش: اینجا زمینه‌ی ویرایش است نه تحلیل
      presets: [
        { key: 'last7', title: '۷ روز' },
        { key: 'last30', title: '۳۰ روز' },
        { key: 'last90', title: '۹۰ روز' },
        { key: 'thisYear', title: 'امسال' },
      ],
    }
  },
  created() {
    this.preset = 'last30'
    // مقایسه در مینی‌گزارش پیش‌فرض خاموش است تا نمودار ساده بماند
    this.filter.Compare = 0
  },
  methods: {
    toggle() {
      this.open = !this.open

      if (this.open && !this.loaded) {
        this.loaded = true
        this.refresh()
      }
    },

    refresh() {
      if (!this.entityId) return

      this.sources.forEach(source => {
        this.$set(this.reportLoading, source.key, true)

        this.$http.post(source.url, { ...this.filter, Id: this.entityId })
          .then(res => {
            this.$set(this.results, source.key, res.data)
            this.$emit('loaded', { key: source.key, data: res.data })
          })
          .catch(() => {})
          .finally(() => this.$set(this.reportLoading, source.key, false))
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.entity-report {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    cursor: pointer;
  }

  &__hint {
    font-size: 0.75rem;
    color: #b9b9c3;
  }
}
</style>
